/**
 * Permission Types and Utilities
 * 
 * Defines user permission levels and utilities for permission-based access control.
 */

/**
 * User permission levels
 * - 'a' = Admin: Full access to all features
 * - 'rw' = Read-Write: Can search and submit actions
 * - 'w' = Write: Can submit and manage actions.
 * - 'r' = Read: Can only search and view
 */
export type Permission = 'a' | 'rw' | 'w' | 'r';

export function isAdmin(permission: string | null | undefined): boolean {
  return permission === 'a';
}

export function hasReadWrite(permission: string | null | undefined): boolean {
  return permission === 'a' || permission === 'rw';
}

export function hasWrite(permission: string | null | undefined): boolean {
  return permission === 'a' || permission === 'rw' || permission === 'w';
}

export function hasRead(permission: string | null | undefined): boolean {
  return permission === 'a' || permission === 'rw' || permission === 'w' || permission === 'r';
}

export function getPermissionLabel(permission: string | null | undefined): string {
  switch (permission) {
    case 'a':
      return 'Administrator';
    case 'rw':
      return 'Read-Write';
    case 'w':
      return 'Write';
    case 'r':
      return 'Read Only';
    default:
      return 'Unknown';
  }
}

